<template>
    <div class="widget bulk-one-to-one-email-widget">
        <div class="widget-header">
            <h3>{{ steps[step].title }}</h3>
            <div class="svg-container widget-close-button" @click="closeWidget">
                <widget-close-svg />
            </div>
        </div>
        <div class="content-wrapper">
            <div v-show="step === 'email'" class="email-step">
                <bulk-email-composer 
                    id="bulk-email-composer"
                    ref="composer"
                    :initialTos="initialTos"
                    :isToEditable="isToEditable"
                ></bulk-email-composer>
            </div>
            <div v-show="step === 'saving'" class="saving-step">
                <loading-screen-svg></loading-screen-svg>
            </div>
        </div>
        <div class="widget-footer">
            <div class="cancel-container">
                <app-button class="transparent-btn" :onClick="closeWidget">Cancel</app-button>
            </div>
            <div class="action-container">
                <button class="btn secondary-btn schedule-btn" v-on:click="openDatePickerWidget">Schedule <span class="svg-container"><clock-svg></clock-svg></span></button>
                <app-button :onClick="steps[step].action" :loading="steps[step].loading">
                    {{ steps[step].buttonText }}
                </app-button>
            </div>
        </div>
    </div>
</template>

<script>
const AppButton = () => import('@/components/common/app-button.vue');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg.vue');
const BulkEmailComposer = () => import('@/components/one-to-one-email/bulk-email-composer.vue');
const LoadingScreenSvg = () => import('@/components/svg/loading-screen-svg');
const ClockSvg = () => import('@/components/svg/clock-svg');

import EventBus from '@/scripts/event-bus.js';

export default {
    name: 'bulk-one-to-one-email-widget',

    props: {
        widget: {
            type: Object,
            required: true
        },
    },

    components: {
        'app-button': AppButton,
        'widget-close-svg': WidgetCloseSvg,
        'bulk-email-composer': BulkEmailComposer,
        'loading-screen-svg': LoadingScreenSvg,
        'clock-svg': ClockSvg
    },

    data() {
        return {
            isInitializing: true,
            initialTos: [],
            isToEditable: false,
            successMessage: '',
            step: null,
            steps: {
                email: {
                    title: 'Bulk Email',
                    buttonText: 'Send',
                    action: this.sendEmails,
                    loading: false
                },

                saving: {
                    title: 'Sending',
                    buttonText: 'Sending',
                    action: null,
                    loading: true
                }
            }
        }
    },

    computed: {
        clientId() {
            return this.$store.state.context.client.id;
        }
    },

    methods: {
        sendEmails() {            
            var isValid = this.$refs.composer.isValid();

            if (isValid) {
                this.step = 'saving';
                this.$refs.composer.hideError();

                this.$refs.composer
                    .sendEmails()
                    .then(() => {
                        this.$helpers.showSuccessNotification(this.successMessage);
                        this.closeWidget();
                    })
                    .catch((error) => {
                        this.step = 'email';
                        this.$helpers.showFailNotification('An error occurred while sending your emails.', { error });
                    });
            } 
            else {
                this.$refs.composer.showError();
            }
        },

        setSuccessMessage(sendDate) {
            if(sendDate) {
                this.successMessage = 'Emails successfully scheduled for <strong>' + this.$moment(sendDate).format('MMM Do, YYYY [at] h:mm a') + '</strong>.' 
            }
            else {
                this.successMessage = 'Emails successfully sent.'
            }
        },

        openDatePickerWidget() {
            var widget = {
                name: 'date-picker-widget'
            };

            EventBus.$emit('open-widget', widget);
        },

        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        }
    },

    created() {
        this.initialTos = this.widget.initialTos || [];
        this.isToEditable = this.widget.isToEditable || false;
        this.step = 'email';

        EventBus.$on('email-status-emitted', this.setSuccessMessage);
    },

    destroyed() {
        EventBus.$off('email-status-emitted');
    }
}
</script>

<style>
.bulk-one-to-one-email-widget .schedule-btn .svg-container path {
    fill: #18AEFF;
}
</style>

<style scoped>
.bulk-one-to-one-email-widget .saving-step {
    text-align: center;
}

.bulk-one-to-one-email-widget .content-wrapper {
    padding: 0;
}

.bulk-one-to-one-email-widget .action-container {
    display: flex;
}

.bulk-one-to-one-email-widget .action-container .btn {
    margin-left: 15px;
}

.bulk-one-to-one-email-widget .cancel-container .btn.transparent-btn {
    background: transparent;
    color: #877D88;
}

.bulk-one-to-one-email-widget .cancel-container .btn.transparent-btn:hover {
    background: #E1E0E5;
}

.bulk-one-to-one-email-widget .action-container .btn.white-btn {
    background: #FFFFFF;
    color: #877D88;
    border: 2px solid #E9E9EF;
}

.bulk-one-to-one-email-widget .secondary-btn {
    color: #18AEFF;
    height: 40px;
    border-radius: 20px;
    padding: 0px 25px;
    font-size: 14px;
    line-height: 17px;
    min-width: 0;
    background-color: transparent;

    transition: background-color 250ms ease-in;
}

.bulk-one-to-one-email-widget .secondary-btn:hover {
    background-color: #DBEDFA;
}

.bulk-one-to-one-email-widget .schedule-btn {
    padding-right: 45px;
    position: relative;
}

.bulk-one-to-one-email-widget .schedule-btn .svg-container {
    position: absolute;
    top: 14px;
    width: 14px;
    top: 12px;
    right: 18px;
}

</style>
